import {
  ErrorCode,
  InfoEventName,
  endAndReportPerformanceMeasure,
  reportError,
  reportInfo,
  startPerformanceMeasure,
} from '@ms/yammer-data/dist/telemetry';
import { PerformanceEventName } from '@ms/yammer-telemetry/dist/performance';
import { isAuthRedirect } from '@ms/yammer-web-authenticators';
import { writeHostingCookies } from '@ms/yammer-web-support/dist/hosting';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';

import { setupAuthenticator } from '../../auth';
import config from '../../config';
import { setLocaleFromUserData } from '../1-main/bootstrapActions';
import { createYammerEmbedStore } from '../1-main/createStore';
import { isPermanentFailure } from '../1-main/isPermanentFailure';
import { loadLoginRenderer } from '../3-render';

import { configure as configureTelemetry } from './telemetry';

export const bootstrap = async () => {
  const authenticator = await setupAuthenticator();

  await configureTelemetry();

  await authenticator.initializeCurrentAccount();

  if (isAuthRedirect()) {
    return;
  }

  let endedWithError = false;
  const measure = startPerformanceMeasure(PerformanceEventName.AuthBootstrap);

  try {
    const yammerToken = await authenticator.acquireToken([config.msal.resources.yammer]);
    writeHostingCookies({ yammerToken, shouldSetSameSite: true });
  } catch (err) {
    endedWithError = isPermanentFailure(err);
    reportError({
      error: err,
      eventProperties: { errorCode: ErrorCode.AuthBootstrapFailed },
    });

    const { store } = createYammerEmbedStore();
    const { dispatch, getState } = store;
    setLocaleFromUserData(dispatch, getState());
    const render = await loadLoginRenderer();
    const renderRoot = document.getElementById('root') as HTMLElement;
    render({ store, target: renderRoot, authenticator });

    throw err;
  } finally {
    reportInfo({
      eventName: InfoEventName.AuthBootstrapInfo,
      eventProperties: {
        isExecutingInIFrame: window.top !== window.self,
        urlRootPath: getUrlRootPath(window.location.pathname),
      },
    });
    endAndReportPerformanceMeasure({
      ...measure,
      eventProperties: { endedWithError },
    });
  }

  location.reload();
};
